/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Swiper from "vux/src/components/swiper/swiper.vue"; // this line is trasformed by vux-loader
import SwiperItem from "vux/src/components/swiper/swiper-item.vue"; // this line is trasformed by vux-loader
import { Grid, GridItem } from 'vant';
import TpDialog from '@/components/NewVuxComponents/TpDialog';
import ModalMapView from '@/components/GaoDeMap/ModalMapView';
import { apinoticelist, apibannerlist, apiinvite, apisystemsettingByCode, apiservicerecommendlist, getEnterprises, getNewHome } from '@/api';
import { menuMapping } from '@/constant';
import SmyGrid from '@/components/SmyGrid/SmyGrid';
import SmyGridItem from '@/components/SmyGrid/SmyGridItem';
import Banner from './components/Banner';
import Notice from './components/Notice';
import HomeCard from './components/HomeCard';
import utils from '@/utils/utils';
export default {
  name: 'Home',
  components: {
    HomeCard: HomeCard,
    Banner: Banner,
    Notice: Notice,
    ViewBox: ViewBox,
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    SmyGrid: SmyGrid,
    SmyGridItem: SmyGridItem,
    TpDialog: TpDialog,
    Grid: Grid,
    GridItem: GridItem,
    ModalMapView: ModalMapView
  },
  data: function data() {
    return {
      codeMap: {},
      menuMapping: menuMapping,
      // banner
      bannerList: [],
      noticeList: [],
      toDoList: [],
      toDoCountObj: {},
      funNavList: [],
      selfCheckList: [],
      contactUsList: [],
      funNavCount: {},
      // 对象，key为code，value为数量
      hasMounted: false,
      showAnonymousModal: false,
      showEventAnonymousModal: false,
      showInviteModal: false,
      inviteTip: {},
      // 邀请提示
      is_anonymous_eval: 0,
      showExecuteModal: false,
      center: [],
      showtMapAddress: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'pageReload'])), {}, {
    // 未登录
    notLogin: function notLogin() {
      return !this.user.id || this.user.id === -1;
    }
  }),
  watch: {
    'codeMap.40013': {
      handler: function handler() {
        this.initAddress();
      },
      immediate: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload'])), {}, {
    initAddress: function initAddress() {
      var _this = this;
      utils.getLngLat(this.codeMap['40013']).then(function (res) {
        _this.center = res;
      }).catch(function (err) {
        console.log(err);
      });
    },
    handleFuncJump: function handleFuncJump(item) {
      switch (item.relation_type) {
        case 1:
          this.$router.push({
            name: 'ServiceItem',
            params: {
              id: item.homepage_id || -1,
              service_type_id: item.relation_info
            },
            query: {
              title: item.service_title || ''
            }
          });
          break;
        case 2:
          break;
        case 3:
          window.open(item.relation_info);
          break;
        case 4:
          this.$router.push({
            name: 'ServiceDetail',
            query: {
              id: item.relation_info
            }
          });
          break;
        case 5:
          this.$router.push({
            name: 'RepairRecord'
          });
          break;
        case 6:
          this.$router.push({
            name: 'Project'
          });
          break;
        case 7:
          this.$router.push({
            name: 'RepairApply'
          });
          break;
        case 8:
          this.$router.push({
            name: 'DOC'
          });
          break;
        case 9:
          this.$router.push({
            name: 'FAQ'
          });
          break;
        case 10:
          this.$router.push({
            // 商城
            name: 'ServiceMallHome'
          });
          break;
        case 11:
          this.$router.push({
            name: 'CustomerProductList'
          });
          break;
        default:
          break;
      }
    },
    handleJump: function handleJump(index) {
      if (index === 0) {
        this.$router.push({
          name: 'FAQ'
        });
      }
      if (index === 1) {
        this.$router.push({
          name: 'DOC'
        });
      }
    },
    init: function init() {
      var _this2 = this;
      var codes = '40008,40010,40011,40012,40013,40014,90001,90002,90003,90004,90005,90006,90007,90008,90009,90010,90011,90012,90013';
      getEnterprises({
        codes: codes
      }).then(function (res) {
        if (res.success) {
          res.data.forEach(function (v) {
            _this2.$set(_this2.codeMap, v.code, v.value);
          });
        }
      });
    },
    evaluateCancel: function evaluateCancel() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      if (this.notLogin) {
        this.$router.push({
          name: 'Login'
        });
      }
      if (v === 1) {
        this.showAnonymousModal = false;
      } else if (v === 2) {
        this.showExecuteModal = false;
      } else if (v === 3) {
        this.showEventAnonymousModal = false;
      }
    },
    funNavClick: function funNavClick(item) {
      this.$router.push({
        name: 'ServiceItem',
        params: {
          id: item.id,
          service_type_id: item.service_type_id
        },
        query: {
          title: item.name
        }
      });
    },
    // 邀请提示操作
    inviteRespond: function inviteRespond(type) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiinvite({
                  invite_result: type,
                  id: _this3.inviteTip.id
                }, 'put');
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this3.$vux.toast.text(type === 2 ? i18n.tc("9") : i18n.tc("10"));
                  _this3.showInviteModal = false;
                } else {
                  _this3.$vux.toast.text(res.message || '');
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    testBtn: function testBtn() {
      this.$router.push('/serviceMall');
    },
    getNewData: function getNewData(id) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getNewHome({
                  card_type: id
                });
              case 2:
                res = _context2.sent;
                if (res.success && id === 1) {
                  _this4.bannerList = res.data.assembly_detail;
                }
                if (res.success && id === 4) {
                  _this4.funNavList = res.data.assembly_detail;
                }
                if (res.success && id === 5) {
                  _this4.selfCheckList = res.data.assembly_detail;
                }
                if (res.success && id === 6) {
                  _this4.contactUsList = res.data.assembly_detail;
                }
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }),
  activated: function activated() {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // banner
              _this5.getNewData(1);
              // 企业公告
              apinoticelist({
                pageIndex: 0,
                pageSize: 5
              }).then(function (res) {
                if (res.success) _this5.noticeList = res.data;
              });
              // 获取匿名评价权限
              _context3.next = 4;
              return apisystemsettingByCode({
                code: 40001
              }).then(function (res) {
                if (res.success) {
                  _this5.is_anonymous_eval = +res.data.value;
                }
              });
            case 4:
              // 检查是否被邀请
              if (_this5.user.id && _this5.user.id !== -1) {
                // 是否被邀请 检测
                apiinvite().then(function (res) {
                  if (res.success && res.data) {
                    _this5.inviteTip = res.data;
                    _this5.showInviteModal = true;
                  }
                });
              }
              // 工单评价
              if (_this5.user.type === 1 &&
              // 评价工单入口
              _this5.user.evaluateState === 0 &&
              // 评价状态 未评价
              _this5.user.oid // 工单号存在
              ) {
                _this5.showAnonymousModal = true;
              }
              // 事件评价
              if (_this5.user.eventEvaluateState === 0 && _this5.user.eventId) {
                _this5.showEventAnonymousModal = true;
              }
              // 回执单
              if (_this5.user.type === 3 &&
              // 回执工单入口
              !_this5.user.receiptState && _this5.user.oid // 工单号存在
              ) {
                _this5.showExecuteModal = true;
              }
              // 未缓存、已清除缓存 部分
              if (_this5.pageReload.home) {
                // 待办事项
                apiservicerecommendlist().then(function (res) {
                  if (res.success) {
                    _this5.toDoList = res.data;
                  }
                });
                // 功能导航
                _this5.getNewData(4);
                _this5._pageReload({
                  home: false
                });
              }
            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  mounted: function mounted() {
    this.hasMounted = true;
  },
  created: function created() {
    this.getNewData(1);
    this.getNewData(4);
    this.getNewData(5);
    this.init();
    // 页面接口重新加载
    this._pageReload({
      home: true
    });
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    apibannerlist({
      type: 1,
      object_id: ''
    }).then(function (res) {
      next(function (vm) {
        if (res.success) vm.bannerList = res.data;
      });
    });
  }
};